// ── Van module manifest ──────────────────────────────────────────────────────
// Keys are the live platform_parts.key values (mirrored in Stripe metadata
// part_key). Each module's geometry is authored around its INSTALLED pose in
// ProceduralVan; `exploded` is the offset it floats at while detached. A
// future GLB swap must honour these keys and the dependency graph.
export const VAN_MODULES = [
  { key: 'core-portal', name: 'Core Portal', van: 'Chassis & body', exploded: [0, 0, 0], requires: [] },
  { key: 'operations', name: 'Operations Engine', van: 'Engine', exploded: [1.5, -0.5, 2.6], requires: ['core-portal'] },
  { key: 'routes-pay', name: 'Routes → Pay', van: 'Drivetrain', exploded: [0.2, -1.3, 1.9], requires: ['operations'] },
  { key: 'invoicing', name: 'Invoicing Engine', van: 'Payment module', exploded: [-1.1, -0.4, 2.8], requires: ['routes-pay'] },
  { key: 'performance', name: 'Performance Intelligence', van: 'Instrument cluster', exploded: [0.9, 1.5, -2.7], requires: ['operations'] },
  { key: 'my-day', name: 'My Day / Calendar', van: 'Navigation console', exploded: [-1.4, 1.0, -3.0], requires: ['core-portal'] },
  { key: 'field-assist', name: 'Field Assist', van: 'Toolbox', exploded: [1.2, -1.2, 3.4], requires: ['core-portal'] },
  { key: 'field-cases', name: 'Field Cases', van: 'Secure compartment', exploded: [-2.8, 0.3, -2.5], requires: ['core-portal'] },
  { key: 'recruitment', name: 'Recruitment & Onboarding', van: 'Crew seats', exploded: [0.8, -1.6, -2.4], requires: ['core-portal'] },
  { key: 'accounting', name: 'Accounting Bridge', van: 'Financial transmission', exploded: [-2.2, -1.4, -1.6], requires: ['invoicing'] },
];

export const MODULE_KEYS = VAN_MODULES.map((m) => m.key);

/** A module's connector may only light when its dependencies are active. */
export function depsSatisfied(key, states) {
  const def = VAN_MODULES.find((m) => m.key === key);
  return (def?.requires || []).every((r) => states[r] === 'active');
}
